var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es521.js.map
